module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "Start"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#int",
      "id": "int",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#int",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hiya!")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("What started as just another Tuesday morning in September, with my normal morning meditation routine, turned into stress city by midafternoon. Between coaching students, answering emails, and dealing with the daily tasks of being a human, I had had enough adulting for one day. However, since it was only noon and I still had a million things on my to-do list, I had no choice but to trudge forward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At about two p.m., I was mentally spent, stressed, and feeling blue. The second I sat back in my chair to take a break, I felt an urge come upon me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I needed chocolate—and I needed it immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I ventured downstairs to see what kind of confections I could find in my pantry. As soon as I passed my dining room, before I even made it to the kitchen, I saw my husband look up at me with what I only remember as a questioning look. It was as if he knew what I was about to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead of hiding it, I looked over and said, “Yes, I’m eating my feelings right now,” and proceeded to walk into the kitchen to grab a dose of dark chocolate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As I made my way out of the kitchen, I caught another glimpse of him before I hit the stairs to go back to my office and casually mumbled, “Don’t judge me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The words “don’t judge me” used to echo in my subconscious after I ate something I didn’t think I should be eating. I carried guilt into every food I felt like I shouldn’t have and typically felt worse after eating anything I labeled as “bad.” Sure, I felt good temporarily. After a candy bar, I felt like I could conquer "), _c('a', {
    attrs: {
      "id": "page2"
    }
  }), _vm._v("the world. An hour later, though, I felt dead to the world. This roller-coaster relationship with food could only last so long before something needed to change.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The way I eat my feelings now is much different from how I ate my feelings when I was growing up. I used to use “bad food” as a reward system. If I went to the gym, I deserved a pizza, and when I started to write, if I wrote two thousand words, I would get some chocolate. I sometimes would pretend I was competing at the Olympics, except the game was normal life tasks and the prize was Sour Patch gummies, the holy grail of food rewards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It wasn’t until I stopped and actually listened to what my body was telling me that I realized that what we eat greatly impacts how we feel—and also how we feel can impact what we eat. Most times a piece of kale will not be able to fix a heartbreak, just like chocolate is not the answer to all your problems at work. (Sorry if you are just finding this out!) Sometimes we need nourishment beyond food and should incorporate what I call “lifestyle foods” in our diet. So maybe kale won’t fix your heartache, but a listening ear might help start the healing process. I learned that if you allow yourself to dig just a little bit deeper and learn to feel your feelings rather than stuff them, you can actually find out what you are lacking that food can’t possibly solve.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once you get to know your body, you will begin to understand that you can truly “eat your feelings” for the benefit of your body and mind—and not just as a temporary mood stabilizer that usually results in a worse mood later on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead of looking at food as “good” or “bad,” you will instead learn to simply nourish your body with foods that make you feel good. Sometimes it’s healthy greens and proteins and other times you might just want that chocolate brownie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So when I say “eat your feelings,” what I mean is that if you are feeling sad, stressed, exhausted, hangry, or bored, you can find comfort in dishes you love and tend to gravitate toward or crave. But instead of processed ingredients, you can make them with mood-boosting ingredients that will nourish you physically.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s okay to feel sad and gravitate toward something like ice cream. This book gives you the opportunity to do that—and simultaneously improve your mood.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "OEBPS/images/3-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "OEBPS/images/3-2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22c2bd70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/int.vue
// module id = 84
// module chunks = 0